<template>
  <div class="body body-privacy">
		<div class="container bg-privacy" style="padding-top: 30px;">
			<div class="row">
				<div class="col-12 col-md-8 offset-md-2">
					<h1 class="font-weight-bolder">Terms of use</h1>
				</div>
			</div>
		</div>
		<div class="container bg-privacy">
			<div class="row">
				<div class="col-12 col-md-8 offset-md-2">
          <p>Effective Date: June 6, 2018</p>
					<p>Thank you for using amcredit.com (together the “website”), or the American Credit, Inc mobile application (the “American Credit, Inc App”, the "App"). By using the website or clicking the “Sign In” button or downloading, installing, accessing or using the American Credit, Inc App, you are agreeing to be bound by the terms of use described below (the “terms of use”), so please read them very carefully. If you do not wish to be bound by these terms of use, do not (i) access or use the website or the American Credit, Inc App; (ii) click the “Accept” button; or (iii) download the American Credit, Inc App. These terms of use are provided on behalf of American Credit, Inc and affiliates (“we”, or “us”).</p>
					<h2>1. Copyright ©. All rights reserved.</h2>
          <p>Copyright in the pages and in the screens displaying the pages, and in the information and material therein and in their arrangement, is owned by American credit, Inc unless otherwise indicated.</P>
          <h2>2. Trademarks</h2>
          <p>American credit and amcredit are trademarks and service marks of American credit, Inc.</p>
          <h2>3. Use of information and materials</h2>
          <p>The information and materials contained in these pages, and the terms, conditions, and descriptions that appear, are subject to change. Unauthorized use of American credit, Inc web sites, app and systems including but not limited to unauthorized entry into American credit, Inc's systems, misuse of passwords, or misuse of any information posted on a site is strictly prohibited. Not all products and services are available in all geographic areas. Your eligibility for particular products and services is subject to final determination by American credit, inc and/or its affiliates. Investment services are not bank deposits or insured by the FDIC or other entity, and are subject to investment risks, including possible loss of principal amount invested.</p>
          <h2>4. Links</h2>
          <p>This site may contain links to web sites controlled or offered by third parties (non-affiliates of American credit, Inc). American credit, Inc hereby disclaims liability for, any information, materials, products or services posted or offered at any of the third party sites linked to this web site. By creating a link to a third party web site, American credit, Inc does not endorse or recommend any products or services offered or information contained at that web site, nor is American credit, Inc liable for any failure of products or services offered or advertised at those sites. Such third party may have a privacy policy different from that of American credit, Inc and the third party website may provide less security than the American credit, Inc site.</p>
          <h2>5. No warranty</h2>
          <p>The information and materials contained in this site, including text, graphics, links or other items are provided "as is", "as available". American credit, Inc does not warrant the accuracy, adequacy or completeness of this information and materials and expressly disclaims liability for errors or omissions in this information and materials. No warranty of any kind, implied, expressed or statutory including but not limited to the warranties of non-infringement of third party rights, title, merchantability, fitness for a particular purpose and freedom from computer virus, is given in conjunction with the information and materials.</p>
          <h2>6. Limitation of liability</h2>
          <p>In no event will American credit, Inc be liable for any damages, including without limitation direct or indirect, special, incidental, or consequential damages, losses or expenses arising in connection with this site or any linked site or use thereof or inability to use by any party, or in connection with any failure of performance, error, omission, interruption, defect, delay in operation or transmission, computer virus or line or system failure, even if American credit, Inc, or representatives thereof, are advised of the possibility of such damages, losses or expenses.</p>
          <h2>7. Submissions</h2>
          <p>All information submitted to American credit, inc via this site and related App shall be deemed and remain the property of American credit, Inc and American credit, Inc shall be free to use, for any purpose, any idea, concepts, know-how or techniques contained in information a visitor to this site provides American credit, Inc through this site. American credit, inc shall not be subject to any obligations of confidentiality regarding submitted information except as agreed by the American credit, inc entity having the direct customer relationship or as otherwise specifically agreed in our privacy policy or required by law.</P>
          <h2>8. Availability</h2>
          <p>This site is not intended for distribution to, or use by, any person or entity in any jurisdiction or country where such distribution or use would be contrary to local law or regulation.</p>
          <h2>9. Additional terms</h2>
          <p>Certain sections or pages on this site may contain separate terms and conditions, which are in addition to these terms and conditions. In the event of a conflict, the additional terms and conditions will govern for those sections or pages.</p>
          <h2>10. Governing law</h2>
          <p>Use of this site shall be governed by all applicable federal and state laws.</p>
        </div>
			</div>
			<br />
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title = "Terms of Use | American Credit";
    meta.content = "Please read our Terms of Service for visiting our website & using our service.";
    keywords.content = "Terms of use, Terms and Conditions, Terms of service";
  }
};
</script>

<style scoped lang="scss">
  .body-privacy {
		color: #5b5b5b;
		padding-top: 90px;
		font-size: 16px;
		.bg-privacy {
			background-color: #f6f6f6;
			h2 {
        font-weight: 700;
        font-size: 24px;
        margin-top: 2rem;
				margin-bottom: 0.75rem;
			}
			p {
				margin: 0 0 .75em;
			}
		}	
	}

	@media screen and (max-width: 768px) {
		.body-privacy {
			padding-top: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// termsofUser.vue?93469394